import { render } from "./SalesTalkPage.vue?vue&type=template&id=87e8754e&scoped=true"
import script from "./SalesTalkPage.vue?vue&type=script&lang=js"
export * from "./SalesTalkPage.vue?vue&type=script&lang=js"

import "./SalesTalkPage.vue?vue&type=style&index=0&id=87e8754e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e8754e"]])

export default __exports__